import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-up-medium, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleUpMedium"><path d="M12 7.22559L5.42188 15H18.5781L12 7.22559Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleUpMedium;
